import { TenantEntitySchema } from '@/entities/Entity'
import { z } from '@/utils/zod'

import { ApiKeySchema } from './ApiKey'

export const ApiLogMethodSchema = z.enum([
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE',
])

export type ApiLogMethod = z.infer<typeof ApiLogMethodSchema>

export const ApiLogResponseSchema = z.object({
    ok: z.boolean(),
    statusCode: z.number().int().nonnegative(),
    content: z.string().nullable(),
})

export const ApiLogApiSchema = z.object({
    id: ApiKeySchema.shape._id.nullable(),
    description: ApiKeySchema.shape.description.nullable(),
})

export const ApiLogSchema = TenantEntitySchema.extend({
    tenant: TenantEntitySchema.shape.tenant.nullable(),
    response: ApiLogResponseSchema,
    method: ApiLogMethodSchema.nullable(),
    requestUrl: z.string().nullable(),
    procedure: z.string().nullable(),
    ipAddress: z.string().nullable(),
    requestPayload: z.string().nullable(),
    apiKey: ApiLogApiSchema,
    requestedAt: z.isoDateTime,
    finishedAt: z.isoDateTime.nullable(),
    duration: z.number().int().nonnegative().nullable(),
})

export type ApiLog = z.infer<typeof ApiLogSchema>
